import { render, staticRenderFns } from "./TableEl.vue?vue&type=template&id=f11945ae&scoped=true&"
import script from "./TableEl.vue?vue&type=script&lang=ts&"
export * from "./TableEl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f11945ae",
  null
  
)

export default component.exports